"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.storeAccessToken = storeAccessToken;
exports.loadAccessToken = loadAccessToken;
exports.getIsAccessTokenLoading = getIsAccessTokenLoading;
exports.setAccessTokenLastRequestTime = setAccessTokenLastRequestTime;
exports.removeAccessToken = removeAccessToken;
var constants_1 = require("../constants");
var DECIMAL_RADIX = 10;
function storeAccessToken(accessToken) {
    localStorage.setItem(constants_1.LOCAL_STORAGE_JWT, accessToken.jwt);
    localStorage.setItem(constants_1.LOCAL_STORAGE_JWT_EXPIRY, accessToken.expiryTimestamp.toString());
}
function loadAccessToken() {
    var jwt = localStorage.getItem(constants_1.LOCAL_STORAGE_JWT) || '';
    var expiryTimestamp = localStorage.getItem(constants_1.LOCAL_STORAGE_JWT_EXPIRY) || '';
    return {
        jwt: jwt,
        expiryTimestamp: parseInt(expiryTimestamp, DECIMAL_RADIX),
    };
}
function getIsAccessTokenLoading() {
    var _a;
    var lastRequestStartedAt = parseInt((_a = localStorage.getItem(constants_1.LOCAL_STORAGE_JWT_LAST_REQUEST_TIME)) !== null && _a !== void 0 ? _a : '0', 10);
    return lastRequestStartedAt + constants_1.MAX_WAITING_TIME > Date.now();
}
function setAccessTokenLastRequestTime(newValue) {
    localStorage.setItem(constants_1.LOCAL_STORAGE_JWT_LAST_REQUEST_TIME, newValue.toString());
}
function removeAccessToken() {
    localStorage.removeItem(constants_1.LOCAL_STORAGE_JWT);
    localStorage.removeItem(constants_1.LOCAL_STORAGE_JWT_EXPIRY);
}
//# sourceMappingURL=localStorageHelper.js.map